<template>
<div class="reset-container animated fadeInUp">
  <v-flex tag="h3">{{$t('view.forgetPwd.title')}}</v-flex>
  <v-subheader>{{$t('view.forgetPwd.instructions')}}</v-subheader>
  <form role="form" v-on:submit.prevent @keyup.enter="resetPassword">
    <!-- USERNAME INPUT -->
    
    <v-flex >
      <v-text-field 
      prepend-icon="person" 
      :label="$t('view.signin.username.placeholder')" 
      type="text"
      v-model="auth.username"
      :disabled="view.action.resetPassword.busy" 
      :error-messages="$t(`validator.${getFirstError($v.auth.username)}.text`,'')"
      v-show="!view.action.resetPassword.busy"
      >
      </v-text-field>
      <!-- <span class="input-group-addon signin--i"><i class="icon-append fa fa-lock"></i></span> 		 -->
      <!-- <input type="text" 
        class="form-control signin--lock" 
        v-model="auth.username"
        v-show="!view.action.resetPassword.busy"
        :disabled="view.action.resetPassword.busy" 
        :placeholder="$t('view.forgetPwd.username.placeholder')" > -->
        <vue-content-loading :width="273" :height="34" v-if="view.action.resetPassword.busy">
          <rect x="0" y="0" rx="4" ry="4" width="273" height="34" />
        </vue-content-loading>
    </v-flex>
    <!-- <transition>        
        <label class="error--text" for="username"
          v-if="hasErrors($v.auth.username)">
          {{$t(`validator.${getFirstError($v.auth.username)}.text`,"")}}
        </label>
    </transition> -->
    <p>
      <label class="error--text" 
        v-if="view.elem.label.resetPasswordError.visible">
        {{errorResetPasswordMessage}}
      </label>
    </p>
    <!-- SUBMIT BUTTON -->
    <v-btn 
    :disabled="hasErrors($v.auth) || view.action.resetPassword.busy" 
    name="loginSubmit"
    @submit="resetPassword()"
    @click="resetPassword()"
    block 
    color="primary">
      {{$t('view.forgetPwd.submit')}}
    </v-btn>
    <!-- <button type="button" 
      class="btn btn-primary block full-width signin--ingresar" 
      :disabled="hasErrors($v.auth) || view.action.resetPassword.busy" 
      @click="resetPassword()">
      <strong>{{$t('view.forgetPwd.submit')}}</strong>
    </button> -->
    <br>
    <router-link  :to="{name:'SignIn'}" :disabled="view.action.resetPassword.busy">
    <small>{{$t('view.forgetPwd.cancel')}}</small>
  </router-link>
  </form>
</div>
</template>
<script>
import Auth from "@/services/auth";
import {AuthenticationModel} from "@/models/authentication";
import {allValidatorMethods} from "@/helpers/vuelidate"
import {valueIsWithin} from "@/helpers/validators";
import {required, minLength, email} from "vuelidate/lib/validators";
import {errors} from "@/locales/languages/es_MX";
import VueContentLoading from 'vue-content-loading';

// List of errors required for changing password flow
const errorsResetPassword = Object.keys(errors.resetPassword);
const errorsChangePassword = Object.keys(errors.changePassword);
const errorsLogin = Object.keys(errors.login);
//Initializing models
//const auth = new AuthenticationModel();
//Element's Settings
const label = {
  resetPasswordError:{
    visible: false
    , text   : ""
  }
};
const button = {
  resetPassword:{
    enable:true
  }
};
//Action's state
const action = {
  resetPassword:{
    busy:false
  }
};
// Component Implementation
export default {
  name: "ForgetPassword",
  head: {
    title: function() {
      return {
        inner       : this.view.title
        , separator : '|'
        , complement: this.$t("view.home.system.initials")
      };
    }
  }
  , data() {
    return {
      auth: undefined
      , locale : this.$i18n.locale
      , view: {
        title: "Restablecer Contraseña"
        , action
        , elem : {
          label
          , button
        }
      }
    };
  }
  , methods: {
    ...allValidatorMethods
    ,  async resetPassword() {
      try{
        // Hide any previous error
        this.hideErrorResetPassword()
        // Validate all models before make the request
        if(!this.isAllValid(this.$v)) return;
        
        this.view.action.resetPassword.busy=true;
        // Calling API to request a reseting 
        const response = await Auth.requestResetPassword(this.auth);
        this.view.action.resetPassword.busy=false;
        this.$router.push({ name: 'ForgetPwdMessage', params: {username:this.auth.username,nombre:response.data.body.results.nombre}});
      }catch(error){
        console.log(error);
        this.view.action.resetPassword.busy=false;
        if(error && (error.status=="500" || error.status=="403"))
          this.showErrorResetPassword(this.$t(`network.errors.${error.status}.desc`));

        const {data:{meta:{code:errorCode}}} = error; 
        // Error's reseting password        
        if(valueIsWithin(errorsResetPassword,errorCode))
          this.showErrorResetPassword(this.$t(`errors.resetPassword.${errorCode}.text`));  
        // Error's reseting password        
        if(valueIsWithin(errorsChangePassword,errorCode))
          this.showErrorResetPassword(this.$t(`errors.changePassword.${errorCode}.text`)); 

        if(valueIsWithin(errorsLogin,errorCode))
          this.showErrorResetPassword(this.$t(`errors.login.${errorCode}.text`)); 

      }
    }
    , showErrorResetPassword(message){
      this.view.elem.label.resetPasswordError.visible=true;
      this.view.elem.label.resetPasswordError.text=message;
    }  
    , hideErrorResetPassword(){
      if(!this.view.elem.label.resetPasswordError.visible)
        return;
      this.view.elem.label.resetPasswordError.visible=false;
      this.view.elem.label.resetPasswordError.text="";
    }
    , setInitialState(){
      this.auth = new AuthenticationModel();
      this.view.elem.label.resetPasswordError.visible=false;
      this.view.elem.label.resetPasswordError.text="";
      document.querySelector('#imageLogo').style.height = "35vh";
    }
  }
  , computed:{
    errorResetPasswordMessage(){
      return this.view.elem.label.resetPasswordError.text
    }
  }
  , validations:{
    auth:{
      username:{
        required
      }
    }
  }
  , components: {
    VueContentLoading
  }
  , created(){
    this.setInitialState()
  }
};
</script>
<!-- Style scoped Implementation -->
<style scoped>
.reset-container{
  position:relative;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/authentication/ForgetPassword.vue